import React, { useState, useEffect } from 'react';
import styles from './Gallery.module.css';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await fetch('/content/gallery.json');
        const data = await res.json();
        setImages(data);
      } catch {
        setImages([]);
      }
    };
    fetchGallery();
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') setLightbox(null);
    };
    if (lightbox !== null) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [lightbox]);

  if (images.length === 0) return null;

  return (
    <section id="gallery" className="section section--alt">
      <div className="section__inner">
        <h2 className="section__title">Gallery</h2>
        <div className={styles.grid}>
          {images.map((img, i) => (
            <div
              key={img.id}
              className={styles.item}
              onClick={() => setLightbox(i)}
            >
              <img src={img.src} alt={img.alt} className={styles.image} />
              <div className={styles.itemOverlay}>
                <span className={styles.itemCaption}>{img.caption}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightbox !== null && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <button
            className="lightbox-close"
            onClick={() => setLightbox(null)}
          >
            &times;
          </button>
          <img
            src={images[lightbox].src}
            alt={images[lightbox].alt}
            onClick={(e) => e.stopPropagation()}
          />
          {images[lightbox].caption && (
            <div className="lightbox-caption">{images[lightbox].caption}</div>
          )}
        </div>
      )}
    </section>
  );
};

export default Gallery;
